<template>
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y :disabled="disabled">
        <template v-slot:activator="{ on }">
            <v-text-field
                data-cy="date-picker-text-field"
                :label="label"
                :class="[
                    {
                        'centered-input': centered,
                        'pt-1': !inOrderDetails,
                        'pt-2 left-input': inOrderDetails,
                        'pt-6': inFilters,
                        ...textfieldClass,
                    },
                ]"
                :prependInnerIcon="prependInnerIcon"
                dense
                hide-details
                v-model="selected"
                v-on:input="$emit('input', $event)"
                v-on="on"
                :value="value"
                color="#154579"
                :disabled="disabled"
                :style="textfieldStyle"
                :clearable="clearable"
                readonly
            />
        </template>

        <v-date-picker data-cy="date-picker-popup" v-model="selected" @blur="date = parseDate(value)" @input="menu = false" :locale="$i18n.locale" :type="dataDisplayType" no-title header-color="#154579" color="#154579" :min="getMinDate()" :max="getMaxDate()" />
    </v-menu>
</template>

<script>
export default {
    props: {
        inOrderDetails: {
            type: Boolean,
            default: false,
        },
        inFilters: {
            type: Boolean,
            default: false,
        },
        dataIsHomologousPeriod: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'Data',
        },
        value: {
            type: String,
            default: '',
        },
        centered: {
            type: Boolean,
            default: true,
        },
        disabled: Boolean,
        textfieldStyle: String,
        textfieldClass: Object,
        prependInnerIcon: String,
        dataDisplayType: {
            type: String,
            default: 'date',
        },
        isfutureDate: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        minDate: {
            type: String,
            default: null,
        },
        maxDate: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            menu: null,
            date: null,
            dateFormatted: null,
        };
    },

    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },

        tomorrow() {
            if (this.isfutureDate) {
                let tomorrow = new Date();
                tomorrow = new Date(tomorrow.setDate(tomorrow.getDate() + 1));

                return tomorrow.toISOString().slice(0, 10);
            }

            return null;
        },
    },

    watch: {
        date() {
            this.$emit('input', this.formatDate(this.date));
        },
    },
    methods: {
        getMinDate() {
            if (this.isfutureDate) return this.tomorrow ?? null;

            return this.minDate ? this.minDate : null;
        },

        getMaxDate() {
            return this.maxDate ? this.maxDate : null;
        },

        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split('-');

            if (this.dataDisplayType === 'month') {
                return `${month.padStart(2, '0')}-${year}`;
            }

            return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
        },

        parseDate(date) {
            if (!date) return null;

            const [day, month, year] = date.split('-');

            if (this.dataDisplayType === 'month') {
                return `${year}-${month.padStart(2, '0')}`;
            }

            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
    },
};
</script>

<style>
.centered-input input {
    text-align: center !important;
}

.v-menu__content {
    min-width: 290px !important;
}
</style>
